import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { PAYPAL_PAYOUTS_ENABLED } from '../config/constants';
import './HelpPage.css';

function RpSection(props) {
  var isDark = props.isDark;
  return (
    <div className={'help-reveal help-fade-up help-delay-' + (props.delay || '1') + ' help-section-card'} style={{
      backgroundColor: isDark ? '#141414' : '#fff',
      border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8'),
      borderRadius: '16px',
      padding: '28px',
      marginBottom: '20px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.04)'
    }}>
      <div className="tw-flex tw-items-center tw-gap-3 tw-mb-4">
        <div style={{
          width: '40px', height: '40px', borderRadius: '10px',
          backgroundColor: props.iconBg || 'rgba(201,168,76,0.1)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0
        }}>
          <i className={'fa fa-' + props.icon} style={{ color: props.iconColor || '#c9a84c', fontSize: '16px' }} />
        </div>
        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a' }}>
          {props.title}
        </h2>
      </div>
      <div style={{ color: isDark ? '#d1d5db' : '#4b5563', fontSize: '15px', lineHeight: '1.7' }}>
        {props.children}
      </div>
    </div>
  );
}

function RpScreenshot(props) {
  var isDark = props.isDark;
  var isMobile = window.innerWidth < 768;
  var src = props.src;
  if (isMobile && isDark) {
    src = src.replace(/\.jpg$/, '-mobile-dark.jpg');
  } else if (isMobile) {
    src = src.replace(/\.jpg$/, '-mobile.jpg');
  } else if (isDark) {
    src = src.replace(/\.jpg$/, '-dark.jpg');
  }
  return (
    <div className="help-screenshot" style={{
      marginTop: '16px',
      marginBottom: '8px',
      borderRadius: '12px',
      overflow: 'hidden',
      border: '1px solid ' + (isDark ? '#2a2a2a' : '#e2e2e2'),
      boxShadow: '0 4px 20px rgba(0,0,0,' + (isDark ? '0.3' : '0.08') + ')'
    }}>
      <img src={src} alt={props.alt || ''} style={{
        width: '100%', display: 'block'
      }} />
    </div>
  );
}

function RpTimelineStep(props) {
  var isDark = props.isDark;
  return (
    <div style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{
          width: '32px', height: '32px', borderRadius: '50%',
          backgroundColor: props.active ? '#c9a84c' : (isDark ? '#2a2a2a' : '#e5e5e5'),
          color: props.active ? '#000' : (isDark ? '#666' : '#999'),
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: '700', fontSize: '13px', flexShrink: 0
        }}>
          {props.num}
        </div>
        {!props.last && <div style={{ width: '2px', flex: 1, backgroundColor: isDark ? '#2a2a2a' : '#e5e5e5', marginTop: '4px' }} />}
      </div>
      <div style={{ paddingBottom: props.last ? 0 : '8px' }}>
        <strong style={{ color: isDark ? '#fff' : '#1a1a1a', display: 'block', marginBottom: '4px' }}>{props.title}</strong>
        <span style={{ fontSize: '14px' }}>{props.children}</span>
      </div>
    </div>
  );
}

class ReceivingPayouts extends Component {
  constructor(props) {
    super(props);
    this.state = { isDark: document.documentElement.classList.contains('tw-dark'), showScrollTop: false };
    this._observer = null;
    this._darkObserver = null;
    this._handleScroll = this._handleScroll.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    var els = document.querySelectorAll('.help-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('help-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function(el) { observer.observe(el); });
      this._observer = observer;
    } else {
      els.forEach(function(el) { el.classList.add('help-visible'); });
    }

    window.addEventListener('scroll', this._handleScroll);
    var self = this;
    this._darkObserver = new MutationObserver(function() {
      var dark = document.documentElement.classList.contains('tw-dark');
      if (dark !== self.state.isDark) self.setState({ isDark: dark });
    });
    this._darkObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  componentWillUnmount() {
    if (this._observer) this._observer.disconnect();
    if (this._darkObserver) this._darkObserver.disconnect();
    window.removeEventListener('scroll', this._handleScroll);
  }

  _handleScroll() {
    var show = window.scrollY > 400;
    if (show !== this.state.showScrollTop) this.setState({ showScrollTop: show });
  }

  render() {
    var isDark = this.state.isDark;

    return (
      <div style={{ backgroundColor: isDark ? '#111' : '#f9fafb', minHeight: '100vh' }}>
        <Helmet><title>Receiving Payouts | Primal Market</title></Helmet>

        {/* Hero */}
        <div style={{
          background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
          padding: '60px 20px 48px',
          textAlign: 'center'
        }}>
          <div>
            <div style={{
              width: '56px', height: '56px', borderRadius: '16px',
              backgroundColor: 'rgba(201,168,76,0.15)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <i className="fa fa-university" style={{ color: '#c9a84c', fontSize: '24px' }} />
            </div>
            <h1 style={{ color: '#fff', fontSize: '32px', fontWeight: '700', marginBottom: '12px', marginTop: 0 }}>
              Receiving Payouts
            </h1>
            <p style={{ color: '#9ca3af', fontSize: '16px', maxWidth: '520px', margin: '0 auto', lineHeight: '1.6' }}>
              How you get paid after selling cards on Primal Market.
            </p>
          </div>
        </div>

        {/* Content */}
        <div style={{ maxWidth: '720px', margin: '0 auto', padding: '32px 16px 64px' }}>

          <RpSection isDark={isDark} icon="link" title="Step 1: Connect Your Stripe Account" delay="1">
            <p style={{ margin: '0 0 12px' }}>
              Before you can receive payouts, you need to connect a <strong>Stripe</strong> account. This is where your earnings will be deposited.
            </p>
            <ol style={{ margin: '0 0 12px', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '8px' }}>Go to <Link to="/settings?tab=payments" style={{ color: '#c9a84c', textDecoration: 'none' }}>Settings → Payments</Link></li>
              <li style={{ marginBottom: '8px' }}>Click <strong>"Connect with Stripe"</strong></li>
              <li style={{ marginBottom: '8px' }}>Complete the Stripe onboarding (takes about 2 minutes)</li>
              <li style={{ marginBottom: '8px' }}>Once connected, you'll see a green checkmark next to your Stripe account</li>
            </ol>
            {PAYPAL_PAYOUTS_ENABLED && (
              <p style={{ margin: 0 }}>
                You can also connect a <strong>PayPal email</strong> for orders paid via PayPal.
              </p>
            )}
            <RpScreenshot isDark={isDark} src="/help/settings-payments.jpg" alt="Settings payments tab with Stripe Connect" />
          </RpSection>

          <RpSection isDark={isDark} icon="exchange" title="How the Payout Flow Works" delay="2">
            <p style={{ margin: '0 0 16px' }}>
              Here's what happens after a buyer purchases your card:
            </p>
            <RpTimelineStep isDark={isDark} num="1" active title="Buyer Pays">
              Funds are collected and held securely by the platform.
            </RpTimelineStep>
            <RpTimelineStep isDark={isDark} num="2" active title="You Ship the Card">
              Ship the card and add tracking info to the order.
            </RpTimelineStep>
            <RpTimelineStep isDark={isDark} num="3" active title="14-Day Hold Period">
              Funds are held for up to 14 days to protect the buyer. If the buyer confirms receipt early, the hold ends sooner.
            </RpTimelineStep>
            <RpTimelineStep isDark={isDark} num="4" active last title="Payout Released">
              {PAYPAL_PAYOUTS_ENABLED
                ? 'Your earnings are transferred to your Stripe account (or PayPal for PayPal orders).'
                : 'All payouts are processed via Stripe Connect. Your earnings are transferred directly to your connected Stripe account.'}
            </RpTimelineStep>
          </RpSection>

          <RpSection isDark={isDark} icon="calculator" title="Understanding Your Earnings" delay="3">
            <p style={{ margin: '0 0 12px' }}>
              For each sale, here's how the money breaks down:
            </p>
            <div style={{
              backgroundColor: isDark ? '#1a1a1a' : '#f9fafb',
              borderRadius: '12px', padding: '20px',
              border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8'),
              marginBottom: '12px'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span>Card price</span>
                <strong style={{ color: isDark ? '#fff' : '#1a1a1a' }}>$8.00</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', color: '#ef4444' }}>
                <span>Platform fee (10%)</span>
                <span>-$0.80</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span>Shipping (flat fee)</span>
                <strong style={{ color: isDark ? '#fff' : '#1a1a1a' }}>+$1.00</strong>
              </div>
              <div style={{ borderTop: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8'), paddingTop: '10px', display: 'flex', justifyContent: 'space-between' }}>
                <strong style={{ color: '#c9a84c' }}>Your payout</strong>
                <strong style={{ color: '#c9a84c', fontSize: '17px' }}>$8.20</strong>
              </div>
            </div>
            <p style={{ margin: 0, fontSize: '13px', color: isDark ? '#777' : '#9ca3af' }}>
              You keep 90% of your item price + all shipping. On orders under $9, your payout may be slightly lower to cover processing costs.
            </p>
          </RpSection>

          <RpSection isDark={isDark} icon="line-chart" title="Your Stripe Dashboard" delay="4">
            <p style={{ margin: '0 0 12px' }}>
              Once your Stripe account is connected, you can access your <strong>Stripe Dashboard</strong> to:
            </p>
            <ul style={{ margin: '0 0 12px', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '6px' }}><strong>View all payouts</strong> — See every transfer from Primal Market</li>
              <li style={{ marginBottom: '6px' }}><strong>Check payout schedule</strong> — Stripe typically deposits funds within 2 business days after release</li>
              <li style={{ marginBottom: '6px' }}><strong>Download reports</strong> — Export transaction history for your records</li>
              <li style={{ marginBottom: '6px' }}><strong>Update bank info</strong> — Change where your payouts go</li>
            </ul>
            <p style={{ margin: 0 }}>
              Access your dashboard at{' '}
              <a href="https://dashboard.stripe.com" target="_blank" rel="noopener noreferrer" style={{ color: '#c9a84c', textDecoration: 'none' }}>
                dashboard.stripe.com
              </a>
            </p>
          </RpSection>

          <RpSection isDark={isDark} icon="clock-o" title="When to Expect Payment" delay="5">
            <p style={{ margin: '0 0 12px' }}>
              Here's a typical timeline from sale to cash in your bank:
            </p>
            <div style={{
              backgroundColor: isDark ? '#1a1a1a' : '#f9fafb',
              borderRadius: '12px', padding: '20px',
              border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8')
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', alignItems: 'center' }}>
                <span><i className="fa fa-shopping-cart" style={{ color: '#c9a84c', marginRight: '8px', width: '16px' }} />Buyer purchases</span>
                <span style={{ color: isDark ? '#777' : '#9ca3af', fontSize: '13px' }}>Day 0</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', alignItems: 'center' }}>
                <span><i className="fa fa-truck" style={{ color: '#c9a84c', marginRight: '8px', width: '16px' }} />You ship + add tracking</span>
                <span style={{ color: isDark ? '#777' : '#9ca3af', fontSize: '13px' }}>Day 1–2</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', alignItems: 'center' }}>
                <span><i className="fa fa-check" style={{ color: '#c9a84c', marginRight: '8px', width: '16px' }} />Buyer confirms (or 14-day auto-release)</span>
                <span style={{ color: isDark ? '#777' : '#9ca3af', fontSize: '13px' }}>Day 3–14</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span><i className="fa fa-university" style={{ color: '#22c55e', marginRight: '8px', width: '16px' }} /><strong>Funds in your bank</strong></span>
                <span style={{ color: '#22c55e', fontSize: '13px', fontWeight: '600' }}>+2 business days</span>
              </div>
            </div>
          </RpSection>

          {/* CTA */}
          <div className="help-reveal help-fade-up help-delay-6" style={{ textAlign: 'center', marginTop: '40px' }}>
            <Link to="/settings?tab=payments" className="tw-no-underline help-cta-btn" style={{
              display: 'inline-block', backgroundColor: '#c9a84c', color: '#000',
              fontWeight: '600', fontSize: '15px', padding: '12px 32px',
              borderRadius: '10px', textDecoration: 'none'
            }}>
              Set Up Payouts
            </Link>
          </div>
        </div>

        {this.state.showScrollTop && (
          <button
            onClick={function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="tw-fixed tw-bottom-6 tw-right-6 tw-w-10 tw-h-10 tw-rounded-full tw-bg-brand-gold tw-text-black tw-border-0 tw-cursor-pointer tw-z-40 tw-flex tw-items-center tw-justify-center"
            style={{ boxShadow: '0 4px 16px rgba(201, 168, 76, 0.3)' }}
            aria-label="Scroll to top"
          >
            <svg className="tw-w-6 tw-h-6" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>
    );
  }
}

export default ReceivingPayouts;
